import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GeneratedReport {
  Id: number;
  Status: number;
  ManagerUuid: number;
}

interface SportReportState {
  lastReportFinished: GeneratedReport | null;
}

const initialState: SportReportState = {
  lastReportFinished: null,
};

export const sportReportSlice = createSlice({
  name: 'sportReports',
  initialState,
  reducers: {
    setReportFinished: (state, action: PayloadAction<GeneratedReport>) => {
      state.lastReportFinished = action.payload;
    },
  },
});

export const { setReportFinished } = sportReportSlice.actions;

export default sportReportSlice.reducer;
